import { FC } from "react";
import { observer } from "mobx-react-lite";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { DialogTitle, DialogDescription, DialogHeader, DialogFooter } from "@/components/ui/dialog";
import { useStore } from "@/hooks/useStore";
import { useAsyncStateStore } from "@/hooks/useAsyncStateStore";
import { structure } from "@/endpoints/dryp/structure";

interface DisableIAndIModalProps {
	structureId: Dryp.StructureId;
	structureName: string;
	onSuccess?: () => void;
}

export const DisableIAndIModal: FC<DisableIAndIModalProps> = observer(({ structureId, structureName, onSuccess }) => {
	const {
		uiStore: { modalStore },
	} = useStore();
	const removeApi = useAsyncStateStore(structure.removeIAndISensors);

	const onDisable = async () => {
		try {
			await removeApi.fetch(structureId);
		} catch {
			return; // failure is surfaced through removeApi.error below
		}
		modalStore.close();
		toast.success(`I&I disabled for "${structureName}".`);
		onSuccess?.();
	};

	return (
		<>
			<DialogHeader>
				<DialogTitle>Disable I&I</DialogTitle>
				<DialogDescription>
					Are you sure you want to disable I&I for "{structureName}"? This removes its I&I sensors.
				</DialogDescription>
			</DialogHeader>

			{removeApi.error && <p className="text-sm text-destructive">{removeApi.error.message}</p>}

			<DialogFooter>
				<Button variant="outline" onClick={() => modalStore.close()} disabled={removeApi.loading}>
					Cancel
				</Button>
				<Button onClick={onDisable} disabled={removeApi.loading}>
					{removeApi.loading ? "Disabling…" : "Disable"}
				</Button>
			</DialogFooter>
		</>
	);
});
